import React from 'react';
import { useParams } from 'react-router-dom';
import Breadcrumbs from '../../components/Breadcrumbs';
import Table from '../../components/Table/Table';
import Layout from '../../layout/Layout';
import adminTables from './tables';
import { Paper } from '@mui/material';


const AdminTablePage = () => {
  const { type, filter } = useParams();
  const seo = {
    title: `${type} / ${filter}`,
  };
  return (
    <Layout seo={seo}>
      <Paper sx={{ width: '100%', overflow: 'hidden', padding: '24px' }}>
        <Breadcrumbs
          links={[
            {
              to: `/admin/manage/${type}`,
              label: type === 'users' ? 'User Management' : 'Offer Management',
            },
            { to: `/admin/manage/${type}/${filter}`, label: adminTables[type][filter].title },
          ]}
        />
        <Table
          key={`${type}-${filter}`}
          tableProps={{ stickyHeader: true }}
          height='calc(100vh - 130px)'
          {...adminTables[type][filter]}
        />
      </Paper>
    </Layout>
  );
};

export default AdminTablePage;
